/**
 * Simple logger utility for backend
 */

const baseLogger = console

export const logger = {
  log: (message: string, ...args: any[]) => {
    baseLogger.log(message, ...args)
  },
  info: (message: string, ...args: any[]) => {
    baseLogger.log(`[INFO] ${message}`, ...args)
  },
  error: (message: string, ...args: any[]) => {
    baseLogger.error(`[ERROR] ${message}`, ...args)
  },
  warn: (message: string, ...args: any[]) => {
    baseLogger.warn(`[WARN] ${message}`, ...args)
  },
  debug: (message: string, ...args: any[]) => {
    if (process.env.NODE_ENV === 'development') {
      baseLogger.debug(`[DEBUG] ${message}`, ...args)
    }
  }
}
